(() => {
  let socialMarkup = '';
  let paymentMarkup = '';

  const nodeFromMarkup = (markup) => {
    if (!markup) return null;
    const template = document.createElement('template');
    template.innerHTML = markup.trim();
    return template.content.firstElementChild;
  };

  const arrangeReferenceFooter = () => {
    const footer = document.querySelector('footer.shopify-section-group-footer-group');
    const brandColumn = footer?.querySelector('.footer-content > :first-child .group-block-content');
    const utilities = document.querySelector('.footer-utilities .utilities');
    if (!footer || !brandColumn || !utilities) return;

    const utilitySocial = utilities.querySelector('.footer-utilities__icons');
    const existingSocial = brandColumn.querySelector('.juniper-footer-socials');

    if (utilitySocial) {
      socialMarkup = utilitySocial.outerHTML;
      existingSocial?.remove();
      utilitySocial.classList.add('juniper-footer-socials');
      brandColumn.append(utilitySocial);
    } else if (!existingSocial && socialMarkup) {
      const restoredSocial = nodeFromMarkup(socialMarkup);
      restoredSocial?.classList.add('juniper-footer-socials');
      if (restoredSocial) brandColumn.append(restoredSocial);
    }

    const sourcePayment = footer.querySelector('.footer-content > .payment-icons');
    const existingPayment = utilities.querySelector('.juniper-footer-payments');

    if (sourcePayment) {
      paymentMarkup = sourcePayment.outerHTML;
      existingPayment?.remove();
      sourcePayment.classList.add('juniper-footer-payments');
      utilities.append(sourcePayment);
    } else if (!existingPayment && paymentMarkup) {
      const restoredPayment = nodeFromMarkup(paymentMarkup);
      restoredPayment?.classList.add('juniper-footer-payments');
      if (restoredPayment) utilities.append(restoredPayment);
    }

    const email = footer.querySelector('.email-signup__input');
    if (email) email.placeholder = 'E-mail';
  };

  const scheduleArrange = () => window.requestAnimationFrame(arrangeReferenceFooter);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleArrange, { once: true });
  } else {
    scheduleArrange();
  }

  document.addEventListener('shopify:section:load', scheduleArrange);
  document.addEventListener('shopify:section:reorder', scheduleArrange);
  document.addEventListener('shopify:block:select', scheduleArrange);
})();
